import { render, staticRenderFns } from "./FO.vue?vue&type=template&id=87a936ca&scoped=true"
import script from "./FO.vue?vue&type=script&lang=js"
export * from "./FO.vue?vue&type=script&lang=js"
import style0 from "./FO.vue?vue&type=style&index=0&id=87a936ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a936ca",
  null
  
)

export default component.exports